module.exports = __webpack_public_path__ + "static/story9-2be024304b90207e26ebf97e7e9687ba.png";